module.exports = __webpack_public_path__ + "img/kai_logo_main.8f93e251.png";